import { MouseBlockerProperties } from "@lib/titan2/dist/game/control/properties/MouseBlockerProperties";
import { AbstractVerticalStakePanelProperties } from "@lib/titan2/dist/game/view/properties/AbstractStakePanelProperties";
export class GameStakeSelectorProperties extends AbstractVerticalStakePanelProperties {
    constructor() {
        super(...arguments);
        this.mouseBlockerProperties = new MouseBlockerProperties(0x000000, 0.6, true);
    }
}
//# sourceMappingURL=GameStakeSelectorProperties.js.map